// extracted by mini-css-extract-plugin
export default {"disclaimer-wrap-inner":"Disclaimer_disclaimer-wrap-inner__mCFKR","accordion-item":"Disclaimer_accordion-item__lFjBx","list":"Disclaimer_list__KKGNe","item":"Disclaimer_item__FLait"};